import Constants from '../../../utils/Constants';
import ScrollAnimation from '../../../utils/ScrollAnimation';
import Amenities from '../components/Amenities';
import separator from '../../../assets/imgs/separator.svg';
import Gallery from '../../home/components/04_gallery/Gallery';
import { useEffect } from 'react';

const images = require.context(
  '../../../assets/imgs/00_accommodation/00_luce',
  true
);
const imageList = images.keys().map((image: any) => images(image));

const Luce = ({ lang }: { lang: Locale.Keys }) => {
  useEffect(() => {
    document.title = 'Villa Luce';
  }, []);

  return (
    <div id={Constants.VILLA_LUCE} className='accommodation_wrapper'>
      <div className='accommodation_hero'>
        <img src={imageList[18]} alt={`${lang.villaLuce.title} hero`} />
        <div className='accommodation_hero_title'>
          <h1>{lang.villaLuce.title}</h1>
        </div>
      </div>
      <div className='accommodation_img'>
        <img src={separator} alt='separator' />
      </div>
      <div className='accommodation_container container'>
        <div className='accommodation_container_info'>
          <ScrollAnimation
            animateIn='fadeIn'
            animateOut='fadeOut'
            duration={500}
          >
            <div className='accommodation_container_info_text'>
              <ScrollAnimation animateIn='fadeInUp' duration={500}>
                {lang.villaLuce.p1}
              </ScrollAnimation>
              <ScrollAnimation animateIn='fadeInUp' duration={500} delay={100}>
                <div className='accommodation_container_info_text_button'>
                  <a
                    href={Constants.bookNowLink}
                    target='_blank'
                    rel='noreferrer'
                    className='opacity_transition_low'
                  >
                    <div>{lang.menu.bookNow}</div>
                  </a>
                </div>
              </ScrollAnimation>
            </div>
            <Amenities lang={lang} />
          </ScrollAnimation>
        </div>
      </div>
      <Gallery lang={lang} imageList={imageList} />
    </div>
  );
};

export default Luce;
